export default __webpack_public_path__ + "static/media/330_dummy2016-fotograf02-mobile-de.0986cc2e.png";